import { render, staticRenderFns } from "./OurPeople.vue?vue&type=template&id=b9f9b558&scoped=true"
import script from "./OurPeople.vue?vue&type=script&lang=js"
export * from "./OurPeople.vue?vue&type=script&lang=js"
import style1 from "./OurPeople.vue?vue&type=style&index=1&id=b9f9b558&prod&scoped=true&lang=css"
import style2 from "./OurPeople.vue?vue&type=style&index=2&id=b9f9b558&prod&lang=scss&scoped=true"
import style3 from "./OurPeople.vue?vue&type=style&index=3&id=b9f9b558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f9b558",
  null
  
)

export default component.exports